<template>
    <verification-process :translation-text="translationText"
                          mobile-dispatch="person/verifyMobileNumber"
                          email-dispatch="person/verifyEmail"
                          otp-dispatch="person/verifyOtpForLogin"
                          register
    ></verification-process>
</template>

<script>
    import VerificationProcess from "../../components/auth/VerificationProcess";

    export default {
        components: {
            VerificationProcess
        },
        name: "Register",
        data: () => ({
            translationText: {
                verifyMobilePageText: {
                    title: 'components.verify_mobile.form_heading.register.title',
                    subtitle: 'components.verify_mobile.form_heading.register.subtitle',
                },
                verifyEmailPageText: {
                  title: 'components.verify_email.form_heading.login.title',
                  subtitle: 'components.verify_email.form_heading.login.subtitle',
                },
                verifyLoaderPageText: {
                    smsTitle: 'components.verify_loader.loader_sms_heading',
                    callTitle: 'components.verify_loader.loader_call_heading',
                    smsInfo: 'components.verify_loader.loader_sms_details',
                    callInfo: 'components.verify_loader.loader_call_details',
                    emailTitle: 'components.verify_loader.loader_email_heading',
                    emailInfo: 'components.verify_loader.loader_email_details',
                    whatsappTitle: 'components.verify_loader.loader_whatsapp_heading',
                    whatsappInfo: 'components.verify_loader.loader_whatsapp_details',
                },
                otpPageText: {
                    title: 'components.otp.form_heading.register.title',
                    smsSubtitle: 'components.otp.form_heading.register.subtitle_sms',
                    callSubtitle: 'components.otp.form_heading.register.subtitle_call',
                    smsAction: 'components.otp.form_actions.resend_button_text',
                    callAction: 'components.otp.form_actions.call_again_button_text',
                    emailSubtitle: 'components.otp.form_heading.login_token.subtitle_email',
                    titleEmail: 'components.otp.form_heading.login_token.title_email',
                    emailAction: 'components.otp.form_actions.send_again_button_text',
                    whatsappSubtitle: 'components.otp.form_heading.login.subtitle_whatsapp',
                    whatsappAction: 'components.otp.form_actions.resend_button_text',
                },
            }
        }),
        methods: {
            // login() {
            //     this.$store.dispatch('person/verifyMobileNumber', {
            //         mobilecountry: 'ZA',
            //         'mobile': '0827755753',
            //         via: 'sms'
            //     }).then(() => {
            //         this.error = null;
            //         this.step = 'verify';
            //     }).catch((error) => {
            //         if (error.status === 422) {
            //             this.error = 'VALIDATION FAILED!!!!!! - ';
            //             console.log(error.data.errors);
            //         } else {
            //             this.error = this.$t('errors.' + error.data.message);
            //         }
            //     })
            // },
            // verify() {
            //     this.$store.dispatch('person/verifyOtpForLogin', {otp: '123456'}).then(() => {
            //         this.error = null;
            //         this.$router.replace('register/info');
            //     }).catch((errorData) => {
            //         this.error = this.$t('errors.' + errorData.message);
            //     })
            // }
        }
    }
</script>

<style scoped>

</style>